function capitalizeFirstLetter(string: string): string {
  if (string.match(/^[ld]'/)) {
    return string.slice(0, 2) + capitalizeFirstLetter(string.slice(2));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default capitalizeFirstLetter;
